import { render } from "./About.vue?vue&type=template&id=3d4d6e61"
const script = {}
script.render = render

export default script